const config = {
    configuration: true,
    buttonList: [
        {
            'type': 'text',
            'icon': 'el-icon-search',
            'label': '查询',
            'size': 'small',
            'event': 'search'
        },
        {
            type: 'text',
            class: 'bigData-btn-ltc-add',
            icon: 'el-icon-circle-plus-outline',
            label: '新增',
            size: 'small',
            event: 'add',
            'ifHas': '07070004'
        },
        {
            type: 'text',
            class: 'bigData-btn-ltc-delete',
            icon: 'el-icon-delete',
            label: '删除',
            size: 'small',
            event: 'delete',
            'ifHas': '07070006'
        }
    ],
    table:
    {
        'switchType': true,
        'tableCut': false,
        'clickState': false,
        'selectBtn': true,
        'btnActive': true,
        leftOperation: true,
        'height': 'calc(100vh - 215px)',
        columns: [
            {
                label: '业务类型',
                prop: 'businessType',
                type: 'select',
                optionNum: 'SYS_BMS_BUSI_TYPE',
                width: '150'
            },
            {
                label: '项目名称',
                prop: 'productName',
                width: '150'
            },
            {
                label: '发票项目名称',
                prop: 'invoiceProductName',
                width: '150'
            },
            {
                label: '税收分类编码',
                prop: 'taxCode',
                width: '150'
            },
            {
                label: '税收分类名称',
                prop: 'taxName',
                width: '150'
            },
            {
                label: '税收编码简称',
                prop: 'taxShortName',
                width: '150'
            },
            {
                label: '是否享受优惠政策',
                prop: 'isEnjoy',
                type: 'select',
                options: [
                    {
                        label: '是',
                        value: 1
                    },
                    {
                        label: '否',
                        value: 0
                    }
                ],
                width: '150'
            },
            {
                label: '优惠政策类型',
                prop: 'preferentialPolicyType',
                type: 'select',
                optionNum: 'SYS_BMS_EIS_TAX_PREF_POLICY_TYPE',
                width: '150'

            },
            // {
            //     label: '增值税特殊管理标识',
            //     prop: 'specialManagementOfVat',
            //     width: '150'

            // },
            {
                label: '税率（%）',
                prop: 'taxRate',
                width: '150'

            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: '150'
            },
            {
                label: '修改时间',
                prop: 'modifyTime',
                width: '150'
            }
        ],
        action: [
            {
                type: 'text',
                label: '编辑',
                size: 'mini',
                event: 'edit',
                'ifHas': '07070005'
            }
        ],
        leftWidth: 60
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50, 100]
    }
};

export default config;
